const cache = new Map()

function loadSingleWordData(gsid) {
  if (!gsid) return null;

  const cached = cache.get(gsid)
  if (cached) return cached

  const promise = new Promise((resolve) => {
    fetch('/api/mapdata/' + gsid)
      .then((response) => response.arrayBuffer())
      .then(buffer => {
        const u32 = new Uint32Array(buffer);

        const points = [];
        const counter = new Map()

        for (const grid of u32) {
          const u16 = new Uint16Array([grid, grid >> 16]);
          const lon = 5 + ((u16[0] + 0.5) * 15) / 65536;
          const lat = 36 + ((u16[1] + 0.5) * 12) / 65536;
          points.push([lon, lat])
          counter.set(grid, (counter.get(grid) || 0) + 1)
        }

        resolve({
          points,
          counter,
          total: u32.length
        })
      })
  })
  cache.set(gsid, promise)
  return promise
}


export function loadWordData(ids) {
  return Promise.all(ids.map(loadSingleWordData))
}
